import React from "react";
import { Helmet } from "react-helmet";

export default function Metas({ title, description, noIndex, children }) {
  return (
    <Helmet>
      {noIndex == true && <meta name="robots" content="noindex" />}
      {noIndex == true && <meta name="googlebot" content="noindex" />}

      <title>{title}</title>
      <meta name="description" content={description} />
      {children}
    </Helmet>
  );
}
